import {useState} from 'react'
import { ProductRuleSearch } from './ProductRuleSearch'
import CreateRule from '../modal/CreateRule'
import usePermission from '../../../../../hook/usePermission'

const ProductRuleHeader = ({productRules}: any) => {
  const [modal, setModal] = useState(false)
  const {hasPermission} = usePermission()
  const toggleModal = () => {
    setModal(!modal)
  }
  const onClose = () => {
    setModal(false)
  }

  return (
    <div className='d-flex justify-content-between mb-10'>
      <div className='d-flex'>
        <ProductRuleSearch productRules={productRules} />
      </div>
      {hasPermission('analytics_automation', 'write') && (
        <div>
          <button onClick={toggleModal} className='btn btn-primary'>
            + Create Rule
          </button>
        </div>
      )}
      {modal && <CreateRule show={modal} onClose={onClose} />}
    </div>
  )
}

export {ProductRuleHeader}
